<app-header></app-header>

<div class="content">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>

<app-footer></app-footer>
